import { AudienceDetails } from '../models/AudienceDetails';
import { AudienceCampaign } from '../models/AudienceCampaign';
import { AudienceDetailsRequest } from '../models/AudienceDetailsRequest';
export class AudienceDetailsService {
    constructor(clientId) {
        this.clientId = clientId;
    }
    /* ====== PUBLIC METHODS (No Properies / Variables beyond this point) ====== */
    APIResponseToAudienceDetails(response) {
        console.log('AudienceDetailsService => APIResponseToAudienceDetails', response);
        const audienceDetails = new AudienceDetails();
        // response(axios wrapper)
        //    .data(axios container for payload)
        //    .data(API container for payload)
        const payload = response.data.data;
        audienceDetails.AudienceID = payload.audienceId;
        audienceDetails.AudienceDetailsID = payload.audienceDetailId;
        audienceDetails.Name = payload.name;
        audienceDetails.Description = payload.description;
        audienceDetails.DynamicCriteria = JSON.parse(payload.dynamicCriteriaJSON);
        audienceDetails.Tags = payload.tagsCSV;
        audienceDetails.Properties = payload.propertiesCSV;
        audienceDetails.IsActive = payload.isActive;
        audienceDetails.IsReadOnly = payload.isReadyOnly;
        audienceDetails.InsertDate = payload.insertDate;
        audienceDetails.UpdateDate = payload.updateDate;
        audienceDetails.AudienceDetailType = payload.audienceDetailType;
        audienceDetails.hasCount = payload.hasCount;
        audienceDetails.IsGenerating = payload.isGenerating;
        if (response.data.data.countsData) {
            audienceDetails.CountUnique = payload.countsData.countUnique;
            audienceDetails.CountTotal = payload.countsData.countTotal;
        }
        return audienceDetails;
    }
    APIResponseForAudienceDetails(response) {
        console.log('AudienceDetailsService => APIResponseForAudienceDetails', response);
        const audienceDetails = new AudienceDetails();
        // response(axios wrapper)
        //    .data(axios container for payload)
        //    .data(API container for payload)
        const payload = response;
        audienceDetails.AudienceID = payload.audienceId;
        audienceDetails.AudienceDetailsID = payload.audienceDetailId;
        audienceDetails.Name = payload.name;
        audienceDetails.Description = payload.description;
        audienceDetails.DynamicCriteria = JSON.parse(payload.dynamicCriteriaJSON);
        audienceDetails.Tags = payload.tagsCSV;
        audienceDetails.Properties = payload.propertiesCSV;
        audienceDetails.IsActive = payload.isActive;
        audienceDetails.IsReadOnly = payload.isReadyOnly;
        audienceDetails.InsertDate = payload.insertDate;
        audienceDetails.UpdateDate = payload.updateDate;
        audienceDetails.AudienceDetailType = payload.audienceDetailType;
        audienceDetails.hasCount = payload.hasCount;
        audienceDetails.IsGenerating = payload.isGenerating;
        if (payload.countsData) {
            audienceDetails.CountUnique = payload.countsData.countUnique;
            audienceDetails.CountTotal = payload.countsData.countTotal;
        }
        return audienceDetails;
    }
    APIResponseToAudienceDetailsList(response) {
        const audienceDetails = [];
        // response(axios wrapper)
        //    .data(axios container for payload)
        //    .data(API container for payload)
        response.data.data.forEach((payload) => {
            const details = new AudienceDetails();
            details.AudienceID = payload.audienceId;
            details.AudienceDetailsID = payload.audienceDetailId;
            details.Name = payload.name;
            details.Description = payload.description;
            if (payload.dynamicCriteriaJSON !== undefined) {
                details.DynamicCriteria = JSON.parse(payload.dynamicCriteriaJSON);
            }
            details.Tags = payload.tagsCSV;
            details.Properties = payload.propertiesCSV;
            details.IsActive = payload.isActive;
            details.IsReadOnly = payload.isReadyOnly;
            details.InsertDate = payload.insertDate;
            details.UpdateDate = payload.updateDate;
            details.AudienceDetailType = payload.audienceDetailType;
            details.hasCount = payload.hasCount;
            details.IsGenerating = payload.isGenerating;
            if (payload.countsData) {
                details.CountUnique = payload.countsData.countUnique;
                details.CountTotal = payload.countsData.countTotal;
            }
            details.countsLastRunDate = payload.countsLastRunDate;
            audienceDetails.push(details);
        });
        return audienceDetails;
    }
    APIResponseToAudienceCampaignsList(response) {
        const audienceCampaigns = [];
        if (response.data.data && response.data.data.length > 0) {
            response.data.data.forEach((payload) => {
                const campaign = new AudienceCampaign();
                campaign.ProjectId = payload.projectId;
                campaign.Name = payload.name;
                campaign.Details = payload.details;
                campaign.CreatedOn = payload.createdOn;
                campaign.ModifiedOn = payload.modifiedOn;
                campaign.Schedule = payload.schedule;
                campaign.Status = payload.status;
                audienceCampaigns.push(campaign);
            });
        }
        return audienceCampaigns;
    }
    SaveAudience(audience, publish) {
        console.log(audience);
        console.log(publish);
        const request = this.ToAudienceDetailsRequest(audience);
        request.Publish = publish;
        if (audience.AudienceDetailsID > 0) {
            return this.UpdateAudience(request);
        }
        else {
            return this.CreateAudience(request);
        }
    }
    ActivateDeactivateAudience(audienceId, status) {
        const data = {
            status
        };
        return window.App.$axios.post(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${audienceId}/status?api_user=${window.eInsightUserEmail}`, data);
    }
    /* ====== PRIVATE METHODS (No public methods beyond this point) ====== */
    ToAudienceDetailsRequest(details) {
        const request = new AudienceDetailsRequest();
        request.AudienceDetailsID = details.AudienceDetailsID;
        request.AudienceID = details.AudienceID;
        request.Description = details.Description;
        request.DynamicCriteriaJson = JSON.stringify(details.DynamicCriteria);
        request.IsActive = details.IsActive;
        request.Name = details.Name;
        request.PropertyCodes = details.Properties;
        request.Tags = details.Tags;
        return request;
    }
    CreateAudience(data) {
        console.log('SERVICE => CreateAudience', data);
        return window.App.$axios.post(`/api/audience/api/v1.0/companyid/${this.clientId}/audience?api_user=${window.eInsightUserEmail}`, data);
    }
    UpdateAudience(data) {
        console.log('SERVICE => UpdateAudience', data);
        return window.App.$axios.post(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${data.AudienceID}?api_user=${window.eInsightUserEmail}`, data);
    }
}
//# sourceMappingURL=AudienceDetailsService.js.map